import React from 'react';
import {Heading, Flex, Box, Stack, Radio, RadioGroup, StackDivider} from '@chakra-ui/react';
import {getServiceType} from '../../helpers/ServiceTypeDictionary';

const SurveyTypesReports = ({serviceTypeValue, setServiceTypeValue, serviceTypes}) => {
  return (
    <Box>
      <Heading fontWeight="bold" fontSize="3xl">
        Survey Types
      </Heading>
      <RadioGroup onChange={val => setServiceTypeValue(parseInt(val))} value={serviceTypeValue}>
        <Flex mx="30">
          <Stack>
            <StackDivider />
            {serviceTypes &&
              serviceTypes?.map(st => {
                return (
                  <Radio key={st} colorScheme={'tertiary'} value={st}>
                    {getServiceType(st).key}
                  </Radio>
                );
              })}
          </Stack>
        </Flex>
      </RadioGroup>
    </Box>
  );
};

export default SurveyTypesReports;
